module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-container",
    attrs: {
      "id": "privacy"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "body-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("1. 个人基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("电话号码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集目的:")]), _vm._v(" "), _c('div', [_vm._v("账号注册、登录使用成者云旗下软件")]), _vm._v(" "), _c('div', [_vm._v("保障用户安全,找回密码等服务")]), _vm._v(" "), _c('div', [_vm._v("账号丢失找回凭证")]), _vm._v(" "), _c('div', [_vm._v("提供客服和售后提供咨询服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("登录注册时")]), _vm._v(" "), _c('div', [_vm._v("默认的用户昵称")]), _vm._v(" "), _c('div', [_vm._v("与客服和售后咨询服务")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况:")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集目的:")]), _vm._v(" "), _c('div', [_vm._v("可作为账号进行账号注册、登录、密码找回时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("账号注册、登录、密码找回时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况:")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("2. 网络身份标识信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称:")]), _vm._v(" "), _c('div', [_vm._v("账号及密码")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("创建账号")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("创建账号时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("昵称")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("完善账号信息；发布信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("会议开启或在通讯录进行展示")]), _vm._v(" "), _c('div', [_vm._v("生成文件的默认署名")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("头像")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("完善账号信息；发布信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("会议开启时，或在通讯录进行展示")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("第三方账号信息（头像、昵称）")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("使用第三方账号进行登录")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("3. 个人常用设备信息")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备品牌")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备型号")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("MAC地址")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("设备唯一识别码(OAID/IMEI/MEID/AndroidID/IDFA/OPENUDID/IDFV/出厂序列号/SIM卡IMSI)")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("屏幕分辨率")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("操作系统版本")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("网络类型")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("网络运营商类型")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("已安装应用列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录与分享时,需要判断是否已经安装需要使用的第三方应用")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("第三方登录与分享")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("应用进程列表")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App启动与会议中针对手机型号进行优化")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("收集1次")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("信息名称：")]), _vm._v(" "), _c('div', [_vm._v("应用崩溃数据")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用目的：")]), _vm._v(" "), _c('div', [_vm._v("App质量保障")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("使用场景：")]), _vm._v(" "), _c('div', [_vm._v("App运行崩溃时")]), _vm._v(" "), _c('div', {
    staticClass: "sub-title"
  }, [_vm._v("收集情况：")]), _vm._v(" "), _c('div', [_vm._v("每次崩溃时收集1次")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3583a9f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3583a9f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/checklist/checklist.vue
// module id = 425
// module chunks = 23